import React from 'react'
import Header from '../../../Components/Header'

function Characteristics() {
    return (
        <div>
            <Header text={"Modifying Characteristics"} link={'/datasheet/characteristics'} />
            <div>
                Data
            </div> <br />
        </div>
    )
}

export default Characteristics